import { Component } from '@angular/core'

@Component({
  selector: 'app-bottom-page-panel',
  templateUrl: './bottom-page-panel.component.html',
  styleUrls: ['./bottom-page-panel.component.scss'],
  standalone: false,
})
export class BottomPagePanelComponent {}
